import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Flex from '../common/Flex';
import TrendingPostCard from './TrendingPostCard';
import { TextBolder12 } from '../../VuexyDesign/atoms/Text';
import { CommunityPostResponse } from '../../api/lib/api/musicKnowledgeHub';
import Loader from '../common/Loader';

function ListTrendingPosts({
  trendingPostsList,
  isFetching,
  isError,
}: {
  trendingPostsList: CommunityPostResponse[] | undefined;
  isFetching: boolean;
  isError: boolean;
}) {
  const { t } = useTranslation('musicKnowledgeHub');
  return (
    <>
      {isFetching === true ? (
        <div className="d-flex justify-content-center">
          <Loader />
        </div>
      ) : (
        <>
          {trendingPostsList && trendingPostsList.length !== 0 && !isError ? (
            <>
              <Flex flexDirection="column" justifyContent="center" mt="4">
                <div className="ml-1">
                  <TextBolder12>{t('musicKnowledgeHub:trending')}</TextBolder12>
                </div>
                <div>
                  {trendingPostsList?.map((postData) => (
                    <TrendingPostCard
                      postData={postData}
                      key={`trending-posts-list-${postData.title}-${postData.id}`}
                    />
                  ))}
                </div>
              </Flex>
            </>
          ) : (
            <></>
          )}
        </>
      )}
    </>
  );
}

export default ListTrendingPosts;
